import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop } from 'lodash';
import StudentReportFilter from '../../../components/Filter/StudentReport.filter.component';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { STUDENT_TABLE_BY_NIK_FIELDS } from '../../../constants/student.constant';
import { validateRequiredFields } from '../../../utils/validation.util';

export default class StudentNumber extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        value: {},
        error: {},
      },
      filtered: false,
    };
    this._handleFormChange = this._handleFormChange.bind(this);
    this._onSearch = this._onSearch.bind(this);
  }

  _handleFormChange(event) {
    const {
      name,
      value,
    } = event.target;
    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          [name]: value,
        },
        error: {
          ...prevState.form.error,
          [name]: '',
        },
      },
    }));
  }

  _onSearch() {
    const { form } = this.state;
    const error = validateRequiredFields(form.value, ['year']);
    this.setState(prevState => ({
      form: {
        value: prevState.form.value,
        error,
      },
    }));
    if (isEmpty(error)) {
      this.setState({ filtered: true });
    }
  }

  render() {
    const { filtered, form } = this.state;
    const { handleGetStudent, handleDeleteStudent } = this.props;
    return (
      <div className="student-number">
        {
          !filtered ? (
            <StudentReportFilter
              year={form.value.year}
              error={form.error.year}
              onSearch={this._onSearch}
              onChange={this._handleFormChange}
            />
          ) : (
            <div>
              <div className="student-number__header">
                <div className="student-number__header-detail">
                  <p>Nama Sekolah</p>
                  <p>: SMK</p>
                </div>
                <div className="student-number__header-detail">
                  <p>Alamat Sekolah</p>
                  <p>: -</p>
                </div>
                <div className="student-number__header-detail">
                  <p>Kotamadya</p>
                  <p>: -</p>
                </div>
                <div className="student-number__header-detail">
                  <p>Kecamatan</p>
                  <p>: -</p>
                </div>
              </div>
              <div className="student-number__content">
                <div className="student-number__content-header">
                  <h1>Buku Nomor Induk Siswa</h1>
                  <h3>Tahun: 2018 - 2019</h3>
                </div>
                <ContentTable
                  showActions={false}
                  onSearchContent={handleGetStudent}
                  tableFields={STUDENT_TABLE_BY_NIK_FIELDS}
                  onClickEdit={this._onClickEdit}
                  onClickDelete={handleDeleteStudent}
                />
              </div>
            </div>
          )
        }
      </div>
    );
  }
}
StudentNumber.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
};
StudentNumber.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
